import {
    SET_CLD_FINE_CH_REG_LATE,
    SET_CLD_FINE_REG_LATE,
    SET_FIN_STATUS,
    SET_FINE_CH_REG_LATE_FLAG,
    SET_FINE_REG_LATE_FLAG,
    SET_SKIP_ALL_FIN,
    SET_STEP_FIN_STD,
    SET_TAB_FIN_STD,
} from '../actionTypes'

const initState = {
    tabFinStd: {tabNo: '1'},
    stepFinStd: {stepNo: 0},
    skipAllFin: false,
    caleFineRegLate: null,
    caleFineChangeRegLate: null,
    skipFineRegLateFlag: false,
    skipFineChangeRegLateFlag: false,
};

export default function (state = initState, action) {
    switch (action.type) {
        case SET_TAB_FIN_STD:
            return action.payload
        case SET_STEP_FIN_STD:
            return action.payload
        case SET_FIN_STATUS:
            return action.payload
        case SET_FINE_REG_LATE_FLAG:
            return action.payload
        case SET_FINE_CH_REG_LATE_FLAG:
            return action.payload
        case SET_CLD_FINE_REG_LATE:
            state.caleFineRegLate = action.payload
            return state
        case SET_CLD_FINE_CH_REG_LATE:
            state.caleFineChangeRegLate = action.payload
            return state
        case SET_SKIP_ALL_FIN:
            return action.payload
        default:
            return state;
    }
}